import { getAwsSignedUrl } from './useAwsSignedUrlQuery';
import { useMutation } from 'react-query';

// https://github.com/TanStack/query/discussions/3675
export const useAwsSignedUrlMutation = () => {
  return useMutation(getAwsSignedUrl);
};
